import { logger } from '../logger/logger'

export const sendGTMEvent = (event) => {
  try {
    window.dataLayer && window.dataLayer.push(event)
  } catch {
    logger.error(`failed to dispatch GTM custom event for ${event.event}`)
  }
}
